import { render, staticRenderFns } from "./MessageBlock.vue?vue&type=template&id=85db76b8&"
import script from "./MessageBlock.vue?vue&type=script&lang=js&"
export * from "./MessageBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports